import { SentryService, isLocalhost, isProduction } from '@web_opxp/features';
import { createRoot } from 'react-dom/client';
import Root from './Root';
import { BuildID } from './base/env';
import './index.scss';

if (!isLocalhost) {
  SentryService.initSentry(isProduction(), BuildID);
}
const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found. Can not start the application!');
}
const root = createRoot(container);
root.render(<Root />);
